import NiceModal from '@ebay/nice-modal-react';
import { useMount, useRequest } from 'ahooks';
import { Controller, useForm } from 'react-hook-form';

import { implog } from '@/api/implog';
import { bindMobile, checkMobile, getVerifyCode } from '@/api/login';
import bindPhoneBg from '@/assets/login/bind-phone-bg.webp';
import Button from '@/components/button';
import { IconPhone } from '@/components/icons/icons';
import Input from '@/components/input';
import showNiceModal from '@/components/nice-modal';
import BlurryLoadingImage from '@/components/progressive-img';
import { ACCESS_USERID_KEY, YK_BIND_PHONE_KEY } from '@/constant/config';
import { Timeout } from '@/modules/Timeout';
import globalStore from '@/stores/store';
import { isInIPA } from '@/utils/apk';
import Storage from '@/utils/Storage';
import { inPwaEnv } from '@/utils/utils';

import CheckPhoneModal from './check';
import styles from './styles.module.less';

const BindPhoneModal = (modal, onClose, innerProps = {}) => {
  const {
    initialAwardconfig: { mobilebind }
  } = globalStore;
  useMount(() => {
    implog('bind_phone_modal_show', { ...innerProps, inIpa: isInIPA(), inPwa: inPwaEnv() });
  });
  const {
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    watch,
    control,
    formState: { errors }
  } = useForm<API.BindMobileRequest>();

  const { runAsync: runSend, loading: codeLoading } = useRequest(getVerifyCode, {
    manual: true
  });

  const { runAsync: runBind, loading: bindLoading } = useRequest(
    async data => {
      const checkRes = await checkMobile(data);
      if (checkRes?.ret === 0 && checkRes?.record?.[0]?.userid) {
        const checkModal = await showNiceModal(
          {
            closable: {
              hideClose: true
            },
            contentStyle: {
              background: 'rgba(0, 0, 0, 0)'
            },
            chaining: true,
            width: '6rem',
            maskClosable: false,
            innerProps: checkRes?.record?.[0],
            render: CheckPhoneModal
          },
          'change-bind-phone-modal'
        );
        if (checkModal?.confirm) {
          checkModal?.onClose();
          // NiceModal.remove('whatsapp-modal');
          return bindMobile(data);
        } else {
          checkModal.onClose?.();
        }
        return {
          ret: -1
        };
      }
      return bindMobile(data);
    },
    {
      manual: true
    }
  );

  const onSubmit = async values => {
    implog('bind_phone_modal_submit', { ...innerProps, inIpa: isInIPA(), inPwa: inPwaEnv() });
    const args = {
      ...values,
      p_userid: Storage.getAccess(ACCESS_USERID_KEY),
      p_type: 1
    };
    const res = await runBind(args);
    if (res.ret === 0) {
      Storage.set(YK_BIND_PHONE_KEY, values.p_mobile);
      await globalStore.fetchBalance();
      globalStore.setUserPhone();
      NiceModal.remove('bind-phone-modal');
    }
  };

  const onSend = async () => {
    const mobile = getValues('p_mobile');

    if (!mobile) {
      setError('p_mobile', {
        message: 'The phone number is incorrect'
      });
      return false;
    }
    clearErrors('p_mobile');
    const res = await runSend({ mobile });
    return res.ret === 0;
  };

  const mobile = watch('p_mobile');
  const code = watch('p_code');

  const smsDisabled = !(mobile?.length === 10);

  const codeDisabled = smsDisabled || !(code?.length === 4);

  return (
    <div className={styles.box}>
      <div className={styles.title}>Bind</div>
      <div className={styles['img_box']}>
        <BlurryLoadingImage loading="lazy" src={bindPhoneBg} alt="" />
        <div className={styles.bindPhoneText}>${mobilebind}</div>
      </div>
      <div className={styles.main}>
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <Controller
            name="p_mobile"
            control={control}
            rules={{
              required: 'Required'
            }}
            render={({ field }) => (
              <Input
                {...field}
                addonBefore={'+1'}
                type="tel"
                pattern="\d*"
                placeholder="Telephone"
                maxLength={10}
                addonAfter={<IconPhone className={styles.phone} />}
                errorText={errors.p_mobile?.message}
              />
            )}
          />

          <div className={styles.codebox}>
            <Controller
              name="p_code"
              control={control}
              rules={{
                required: 'Required'
              }}
              render={({ field }) => (
                <Input
                  {...field}
                  maxLength={4}
                  color="black"
                  type="tel"
                  pattern="\d*"
                  placeholder="Enter SMS"
                  className={styles.code}
                />
              )}
            />

            <Timeout type="success" onSend={onSend} sending={codeLoading} disabled={smsDisabled} />
          </div>
          <Button disabled={bindLoading || codeDisabled} block htmlType="submit" type="success" size="large">
            Bind Now
          </Button>
        </form>
      </div>
    </div>
  );
};

export default BindPhoneModal;
